import { makeVar, useReactiveVar } from "@apollo/client";
import { isSameMinute, startOfMinute } from "date-fns";

const FIVE_SECONDS = 5 * 1000;

const getNow = (): number => startOfMinute(Date.now()).getTime();

const nowVar = makeVar<number>(getNow());

export const updateNow = () => {
  const now = getNow();
  if (!isSameMinute(nowVar(), now)) {
    nowVar(now);
  }
};

setInterval(updateNow, FIVE_SECONDS);

export const useNow = (): number => {
  return useReactiveVar(nowVar);
};
